import { zodResolver } from '@hookform/resolvers/zod';
import { Resolver, UseFormProps } from 'react-hook-form';
import { z } from 'zod';

import { deviceFormError } from '../../../../variables';

const homeScreenWelcomeTextSchema = z.object({
  pl: z.string().min(1, 'Please enter a valid description.{2}'),
  en: z.string().optional(),
  de: z.string().optional(),
  fr: z.string().optional(),
  ru: z.string().optional(),
  sk: z.string().optional(),
  no: z.string().optional(),
});
export const schemaDevice = z.object({
  name: z.string().min(1, deviceFormError.name.empty),
  associated_organization: z.string().min(1, deviceFormError.organization.empty),
  model: z.object({
    color: z.string().min(1, deviceFormError.model.color),
    size: z.string().min(1, deviceFormError.model.size),
  }),
  homeScreenWelcomeText: homeScreenWelcomeTextSchema,
  homeScreenImg: z.string().min(1, deviceFormError.homeScreenImg.empty),
  settings: z.object({
    menuSettings: z.object({
      homeScreen: z.array(z.string()).max(10, deviceFormError.homeScreenMenu.invalid),
      slideMenu: z.array(z.string()).optional(),
      welcomeScreen: z.array(z.string()).max(4, deviceFormError.welcomeScreenMenu.invalid),
    }).optional(),
    showSection: z.object({
      foods: z.boolean(),
      forkids: z.boolean(),
      otherplaces: z.boolean(),
      culture: z.boolean(),
      trips: z.boolean(),
    }).optional(),
  }).optional(),
  externalApp: z.string().optional(),
  languages: z.array(z.string()),
});

export type DeviceEntity = z.infer<typeof schemaDevice>;

const deviceResolver: Resolver<DeviceEntity> = zodResolver(schemaDevice) as never;

export const deviceFormOptions: UseFormProps<DeviceEntity> = {
  mode: 'onSubmit',
  resolver: deviceResolver,
};
